import { render, staticRenderFns } from "./table-view.vue?vue&type=template&id=61367f1b&scoped=true&"
import script from "./table-view.component.ts?vue&type=script&lang=ts&"
export * from "./table-view.component.ts?vue&type=script&lang=ts&"
import style0 from "./table-view.vue?vue&type=style&index=0&id=61367f1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61367f1b",
  null
  
)

export default component.exports